(function () {
	window.js = window.js || {};
	js.header = (function () {
		function initialize(domElm) {
			
			var
				oParent = document.querySelector("body"),
				oNav = document.getElementById('header'),
				nNavHeight = oNav.getBoundingClientRect().height,
				nLastPos = scrollPosition(),
				oLabel = document.querySelectorAll("[for*='toggle']"),
				nLabel = oLabel.length,
				oInput = document.getElementById("no-toggle");
				
				window.addEventListener("scroll", throttle(function() {
					var
					nScrollPos = scrollPosition(),
					bScrollDir = nScrollPos > nLastPos;

					if (bScrollDir && (nScrollPos > nNavHeight) && oInput.checked) {
						oParent.classList.remove("sticky--nav");
					}
					if (!bScrollDir && (nScrollPos > nNavHeight) && oInput.checked) {
						oParent.classList.add("sticky--nav");
					}

					nLastPos = nScrollPos;
				}, 160));

				function scrollPosition() {
					return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
				}
			
			
			while(nLabel--) oLabel[nLabel].addEventListener('click', function(){
				
				if (oInput.checked){ oParent.classList.add('sticky--nav')};
			});
			
			
			// Function also used in Share.js
			function throttle(fn, threshhold, scope) {
				threshhold = typeof threshhold !== "undefined" ? threshhold : 250;
				var
					last,
					deferTimer;
				return function () {
					var
						context = scope || this,
						now = +new Date(),
						args = arguments;
					if (last && now < last + threshhold) {
						clearTimeout(deferTimer);
						deferTimer = setTimeout(function () {
							last = now;
							fn.apply(context, args);
						}, threshhold);
					} else {
						last = now;
						fn.apply(context, args);
					}
				};
			}

		}
		return {
			initialize: initialize
		};

	})();
})();